(function () {
  const FORM_ID = '798529';
  const STORAGE_KEY = 'shopify_form_submitted_' + FORM_ID;
// If already submitted, suppress this specific form
  if (localStorage.getItem(STORAGE_KEY) === 'true') {
    document.documentElement.classList.add('shopify-form-' + FORM_ID + '-suppressed');
  }
// Listen for Shopify Forms submission events
  document.addEventListener('shopify:form:submitted', function (event) {
    if (
      event.detail &&
      event.detail.formId &&
      event.detail.formId.toString() === FORM_ID
    ) {
      localStorage.setItem(STORAGE_KEY, 'true');
      document.documentElement.classList.add('shopify-form-' + FORM_ID + '-suppressed');
    }
  });
})();